const LANGUAGE_TO_HTML_LANG: Record<string, string> = {
  afrikaans: "af",
  albanian: "sq",
  amharic: "am",
  arabic: "ar",
  armenian: "hy",
  azerbaijani: "az",
  basque: "eu",
  belarusian: "be",
  bengali: "bn",
  bosnian: "bs",
  bulgarian: "bg",
  catalan: "ca",
  cebuano: "ceb",
  chichewa: "ny",
  "chinese (simplified)": "zh-Hans",
  "chinese (traditional)": "zh-Hant",
  corsican: "co",
  croatian: "hr",
  czech: "cs",
  danish: "da",
  dutch: "nl",
  english: "en",
  "english (au)": "en-AU",
  "english (ca)": "en-CA",
  "english (uk)": "en-GB",
  "english (us)": "en-US",
  esperanto: "eo",
  estonian: "et",
  filipino: "fil",
  finnish: "fi",
  french: "fr",
  "french (canada)": "fr-CA",
  "french (france)": "fr-FR",
  galician: "gl",
  georgian: "ka",
  german: "de",
  greek: "el",
  gujarati: "gu",
  "haitian creole": "ht",
  hausa: "ha",
  hawaiian: "haw",
  hebrew: "he",
  hindi: "hi",
  hmong: "hmn",
  hungarian: "hu",
  icelandic: "is",
  igbo: "ig",
  indonesian: "id",
  irish: "ga",
  italian: "it",
  japanese: "ja",
  javanese: "jv",
  kannada: "kn",
  kazakh: "kk",
  khmer: "km",
  kinyarwanda: "rw",
  korean: "ko",
  "kurdish (kurmanji)": "ku",
  kyrgyz: "ky",
  lao: "lo",
  latin: "la",
  latvian: "lv",
  lithuanian: "lt",
  luxembourgish: "lb",
  macedonian: "mk",
  malagasy: "mg",
  malay: "ms",
  malayalam: "ml",
  maltese: "mt",
  maori: "mi",
  marathi: "mr",
  mongolian: "mn",
  "myanmar (burmese)": "my",
  nepali: "ne",
  norwegian: "no",
  "odia (oriya)": "or",
  pashto: "ps",
  persian: "fa",
  polish: "pl",
  portuguese: "pt",
  "portuguese (brazil)": "pt-BR",
  "portuguese (portugal)": "pt-PT",
  punjabi: "pa",
  romanian: "ro",
  russian: "ru",
  samoan: "sm",
  "scots gaelic": "gd",
  serbian: "sr",
  sesotho: "st",
  shona: "sn",
  sindhi: "sd",
  sinhala: "si",
  slovak: "sk",
  slovenian: "sl",
  somali: "so",
  spanish: "es",
  "spanish (argentina)": "es-AR",
  "spanish (latin america)": "es-419",
  "spanish (mexico)": "es-MX",
  "spanish (spain)": "es-ES",
  sundanese: "su",
  swahili: "sw",
  swedish: "sv",
  tajik: "tg",
  tamil: "ta",
  tatar: "tt",
  telugu: "te",
  thai: "th",
  turkish: "tr",
  turkmen: "tk",
  ukrainian: "uk",
  urdu: "ur",
  uyghur: "ug",
  uzbek: "uz",
  vietnamese: "vi",
  welsh: "cy",
  xhosa: "xh",
  yiddish: "yi",
  yoruba: "yo",
  zulu: "zu",
};

export const languageToHtmlLang = (language?: string): string => {
  if (!language) return "en";
  return LANGUAGE_TO_HTML_LANG[language.toLowerCase()] || "en";
};
